import { AxiosError } from "axios";
import { Priority } from "../../../@types/priority";
import { MutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";
import { apisiseci } from "../../api";
import { toast } from "react-toastify";
import { AxErrorResponse } from "../../../@types/axios-error-response";

export type PriorityUpdateData = {
    nome: string;
    descricao: string;
    peso: number;
    ativo: boolean;
    cor_tag: string;
    cor_fonte: string;
    sigla_senha: string;
    icone: string | File;
};

export function usePriorityUpdate(id: Priority["id"], options?: MutationOptions<Priority, AxiosError<AxErrorResponse>, PriorityUpdateData, unknown>) {
    const history = useHistory();
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation<
        Priority,
        AxiosError<AxErrorResponse>,
        PriorityUpdateData
    >({
        mutationKey: ["priority", "update", id],
        mutationFn: async (data) => {
            if (typeof data.icone === "string") {
                delete data.icone;
            }

            const payload = new FormData();
            Object.entries(data).forEach(([key, value]) => {
                if (value instanceof File) {
                    payload.append(key, value);
                } else if (Array.isArray(value)) {
                    if (value.length === 1) {
                        payload.append(key, String(value[0]) + ',');
                    } else {
                        payload.append(key, String(value));
                    }
                } else {
                    payload.append(key, String(value));
                }
            });
            const response = await apisiseci.put<Priority>(
                `/cms/prioridades/${id}/`, payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    }
                }
            );
            return response.data;
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: ["priority", "list"]
                }),
                queryClient.invalidateQueries({
                    queryKey: ["priority", "details", id]
                }),
            ]);

            toast.success("Prioridade atualizada com sucesso!");
            history.goBack();
        },
        onError: (error) => {
            console.error("Error updating priority:", error);
            const data = error?.response?.data || {};

            Object.keys(data).forEach((key) => {
                if (Array.isArray(data[key]) && data[key].length > 0) {
                    toast.error(data[key][0]);
                } else if (typeof data[key] === "string") {
                    toast.error(data[key]);
                }
            });

            if (Object.keys(data).length === 0) {
                toast.error("Algo deu errado, tente novamente!");
            }
        },
        ...options,
    });

    return mutation;
}
